import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mprd-public-wifi-pxsplus-howtoinstall',
  templateUrl: './public-wifi-pxsplus-howtoinstall.component.html',
  styleUrls: ['./public-wifi-pxsplus-howtoinstall.component.css'],
})
export class PublicWifiPxsplusHowtoinstallComponent implements OnInit {
  hasError = true;
  systemVersion = 0;

  constructor() {}

  ngOnInit(): void {
    this.systemVersion =
      sessionStorage !== null &&
      parseInt(sessionStorage?.getItem('mprdSystemVersion'));

    if (this.systemVersion >= 10) {
      this.hasError = false;
    }
  }
}
